export default __webpack_public_path__ + "static/media/loading.09338589.gif";